import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import {videoReducer} from './stores/root-store/reducers/video.reducer';
import {EffectsModule} from '@ngrx/effects';
import {VideoEffect} from './stores/root-store/effects/video.effect';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {HttpService} from './services/http.service';
import {VideoService} from './services/video.service';
import {NavigationService} from './services/navigation.service';
import {OverlayService} from './services/overlay.service';
import {FrameService} from './services/frame.service';
import {AssetPipe} from './pipes/asset.pipe';
import {AnimationInitService} from './services/animation-init.service';
import {AnimationService} from './services/animation.service';
import {AudioService} from './services/audio.service';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {MatMenuModule} from '@angular/material/menu';
import {ExternalActionsEffect} from './stores/root-store/effects/external-actions.effect';

@NgModule({
    declarations: [
        AssetPipe,
        SafeHtmlPipe,
        ClickOutsideDirective
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        StoreModule.forRoot({
            video: videoReducer
        }, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
        EffectsModule.forRoot([VideoEffect, ExternalActionsEffect]),
        StoreDevtoolsModule.instrument({
            maxAge: 50
        }),
        MatMenuModule
    ],
    providers: [
        HttpService,
        VideoService,
        AnimationInitService,
        AnimationService,
        NavigationService,
        OverlayService,
        FrameService,
        AudioService
    ],
    exports: [
        StoreModule,
        AssetPipe,
        SafeHtmlPipe,
        ClickOutsideDirective
    ]
})
export class SharedModule {
}
